export default {
  账号: 'アカウント',
  密码: 'パスワード',
  重置: 'リセット',
  登录: 'ログイン',
  请输入密码: 'パスワードを入力してください',
  '密码长度在 3 到 5 个字符': 'パスワードの長さは3～18文字です',
  请输入账号: 'アカウントを入力してください',
  返回登录: 'ログイン画面に戻る',
  进入仓库: '倉庫に入る',
  无权限: '権限がありません',
  中文: "中国語",
  日文: "日本語",
  "去选择仓库！": "倉庫を選択してください！",
  未登录: 'ログアウト状態',
  "登录失效，重新登入！": "ログインの有効期限が切れました。再ログインしてください。"
}